import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { SearchBlack } from "../../../../components/Icons/Icons";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import axiosClient from "../../../../services/axiosClient";
import { actions } from "../../../../store";
import ModalListCamera from "./ModalListCamera";
import styles from './ServicesRegisted.module.css';
import TableListService from "./TableListService";

const cx = classNames.bind(styles);

function ServicesRegistered() {
    const [inputTextSearch, setInputTextSearch] = useState()
    const [isModal, setIsModal] = useState(false)
    const [nameService, setNameService] = useState('')
    // eslint-disable-next-line
    const [dataStore, dispatch] = useStoreContext()
    const [listPackRegistered, setListPackRegistered] = useState()

    const onChangeTextSearch = (e) => {
        setInputTextSearch(e.target.value)
    }

    const handleShowListCamera = (data) => {
        setIsModal(!isModal)
        setNameService(data)
    }

    const getNewPackService = () => {
        dispatch(actions.focusOnRedirect('list'))
    }

    useEffect(() => {
        const getDataListCamera = async () => {
            const res = await axiosClient.get(`/serviceRegister/get-list-service_register/`, {
                subject_name_service: inputTextSearch
            })
            setListPackRegistered(res)
        }
        getDataListCamera()
    }, [inputTextSearch])
    return (
        <>
            <div className={cx('wrapper')}>
                <div className={cx("filter")}>
                    <div className={cx("search")}>
                        <input
                            className={cx("search-input")}
                            value={inputTextSearch}
                            onChange={e => onChangeTextSearch(e)}
                            placeholder="Tìm kiếm..."
                        />
                        <span className={cx("icon-search")}>
                            <SearchBlack />
                        </span>
                    </div>

                    <div
                        className={cx('btn')}
                        onClick={getNewPackService}
                    >
                        Thêm dịch vụ
                    </div>
                </div>
                <TableListService
                    handleShowListCamera={handleShowListCamera}
                    listPackRegistered={listPackRegistered}
                />
                {isModal &&
                    <ModalListCamera getHideModal={handleShowListCamera} nameService={nameService} />
                }
            </div>
        </>
    )
}

export default ServicesRegistered;